<template>
  <div class="reset-password-mail">
    <back-navigation-header :on-back="onBack"/>
    <div class="content">
      <img :src="require('@/assets/2fa-login/shield.svg')" class="shield-img">
      <span class="mini-title r-typo-headline-label">איפוס סיסמה</span>
      <div class="title r-typo-headline">מצוין, הסיסמה אופסה בהצלחה</div>
      <span class="text">אפשר להמשיך ולהכנס לשירות עם הסיסמה החדשה
      </span>
      <div class="bottom-button-wrapper">
        <riseup-button class="button" :action="next" :title="'כניסה לשירות'"/>
      </div>
    </div>
    <login-support-footer-positioned/>
  </div>
</template>

<script>

import BackNavigationHeader from '@/base-components/app-header/BackNavigationHeader.vue';
import BaseUI from 'base-ui';
import router from '@/router';
import Segment from '@/Segment';
import LoginSupportFooterPositioned from '@/base-components/LoginSupportFooterPositioned';

export default {
  name: 'TwofaResetPasswordDone',
  async created() {
    Segment.trackUserGot('2faPasswordResetSuccessfullyEntered');
  },
  methods: {
    onBack() {
      router.go(-1);
    },
    next() {
      Segment.trackUserInteraction('2faResetDoneGoToCashflowClicked');
      window.location.href = `/${this.$route.query.redirectTo || 'sr'}`;
    },
  },
  components: {
    LoginSupportFooterPositioned,
    BackNavigationHeader,
    RiseupButton: BaseUI.RiseupButton,
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/mixins';
@import "~base-ui/src/scss/riseup-colors";

.reset-password-mail{
  justify-content: space-between;
  position: relative;

  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    margin: 65px 30px 30px 30px;
    display: flex;
    flex-direction: column;
  }

  .shield-img {
    width: 15%;
  }

  .mini-title {
    padding-top: 40px;
  }

  .title {
    padding: 15px 0;
  }

  .text {
    font-size: 18px;
    line-height: 26px;

    .bold {
      font-weight: bold;
    }
  }
  .bottom-button-wrapper {
    margin-top: 64px;
    margin-bottom: 30px;
    width: 100%;

  }

  .button {
    width: 100%;
    height: 75px;
  }
}
</style>
